module.exports = "/_next/static/resources/photo-3-935932eed9563a7c7a200743f02d3934.webp";